import { CaretDownOutlined } from "@ant-design/icons";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  Checkbox,
  FormControl,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Select as AntSelect } from "antd";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { neutral, primaryColor } from "../../../constants/colorConstants";
import { EMISSION_DATA_STATUS_TYPE, STEPS } from "../../../constants/enums";
import { successMessage } from "../../../constants/messageConstants";
import {
  checkPermissions,
  dateParser,
  parseDateMonth,
  toastMessage,
} from "../../../helper";
import {
  getEmissionCurrencyService,
  getEmissionListSummaryService,
  getUOMService,
  updateEmissionAttachmentService,
  updateEmissionLogService,
  updateEmissionVerifierStatus,
} from "../../../services/emissionService";
import FileAttachments from "../../common/FileAttachments";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import { getSourceNameByCategory, getSourceValue } from "../EmissionConfig";
import "./EmissionDetailedView.scss";
import EmissionVersionHistory from "./EmissionVersionHistory";

function EmissionDetailedView(props: any) {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const {
    onClose,
    controller,
    total_count,
    currentIndex,
    navigateNext,
    id,
    statusOptions,
    handleStatusChange,
    handleExternalVerifierStatus,
    cellColumnsForVerifer,
    eachEmissionData,
    tab,
  } = props;
  const [statusData, setStatusData] = useState() as any;
  const { page, limit } = controller;
  const { Option } = AntSelect;
  let index = limit * page + currentIndex;
  const [emissionData, setEmissionData] = useState<any>([
    {
      status: "",
      id: "",
      to_date: "",
      last_updated: "",
      last_updated_by_name: "",
      category: "",
      category_code: "",
      category_name: "",
      total_value: "",
      from_date: "",
      method_name: "",
      method: "",
      year: "",
      type: "",
      type_name: "",
      sub_type: "",
      sub_type_name: "",
      comments: "",
    },
  ]);
  const [versionHistoryData, setVersionHistoryData] = useState([] as any[]);
  const [cellColumns, setCellColumns] = useState([
    "Sources",
    "Total",
    "",
    "",
    "",
  ]);
  const [toggleSave, setToggleSave] = useState(false);
  const [editAttachmentsData, setEditAttachmentsData] = useState(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [emissionAttachmentData, setEmissionAttachmentData] = useState({
    id: "",
    attachments: [],
  } as any);
  const [emissionLogAttachmentData, setEmissionLogAttachmentData] = useState({
    id: "",
    attachments: [],
  } as any);
  const [emissionLog, setEmissionLog] = useState([
    {
      id: "",
      emission_source: "",
      emission_source_sub_type: "",
      sub_source_name: "",
      engine_name: "",
      engine_id: "",
      total_value: "",
      log_code: "",
      value: "",
      values: {},
      uoms: [],
      uom_name: "",
      uomName: "",
      country: "",
      source_id: "",
      uom: "",
      fuel_id: "",
      isHover: false,
      showIcons: false,
      isEditSelected: false,
      showSave: false,
      year: "",
      emission_factor_code: "",
      emissionfactor_from_date: "",
      emissionfactor_to_date: "",
      is_default: false,
      attachments: [],
      editedValue: "",
      local_code: "",
      gwp_values: {},
      factor_source_name: "",
      original_description: "",
    },
  ]);
  const [noOfImagesUpload, setNoOfImagesUpload] = useState(0);
  const handleOpenAttachments = (index: any) => {
    setShowAttachment(true);
    setEmissionLogAttachmentData({
      attachments: emissionLog[index].attachments,
      id: emissionLog[index].id,
      sourceDetail: {
        sourceValue: getSourceValue(emissionData[0], emissionLog[index]),
        engine_name: emissionLog[index]?.engine_name,
        total: emissionLog[index]?.value,
      },
    });
  };
  useEffect(() => {
    getEmissionListSummaryService({ id: id }).then((res) => {
      console.log("data :", res.data);
      const data = res.data;
      setEmissionAttachmentData({
        attachments: [...res.data.emission[0].attachments],
        id: res.data.emission[0].id,
      });
      setVersionHistoryData(res.data.emissionTransactions);
      if (eachEmissionData && Object.keys(eachEmissionData)?.length) {
        setStatusData({
          ...eachEmissionData,
          status: res.data.emission[0].status,
        });
      } else {
        setStatusData(res.data.emission[0]);
      }
      let tempList: any = [];
      data.emissionLogs.map((value: any, index: number) => {
        let tempObject = {
          ...value,
          isHover: false,
          showIcons: false,
          editedValue: value.value,
          isEditSelected: false,
          showSave: false,
        };
        if (value.engine_name || value.fuel_name) {
          const sep = value.engine_name && value.fuel_name ? "-" : "";
          value.engine_name = value.engine_name || "";
          value.fuel_name = value.fuel_name || "";
          tempObject.engine_name = `${value.engine_name}${sep}${value.fuel_name}`;
        }
        tempList.push(tempObject);
      });
      setEmissionData(data.emission);
      setEmissionLog(tempList);
    });
  }, [props, toggleSave]);
  const onNavigateNext = (increment: number) => {
    if (increment > 0 && currentIndex === limit - 1) {
      navigateNext(increment, 1);
    } else if (increment < 0 && currentIndex === 0) {
      navigateNext(increment, -1);
    } else {
      navigateNext(increment, 0);
    }
  };

  const handleEdit = async (index: number) => {
    emissionLog[index].isEditSelected = true;
    emissionLog[index].showSave = true;
    emissionLog.forEach((eachLog: any, id: number) => {
      if (id !== index) {
        eachLog.isEditSelected = false;
        eachLog.showSave = false;
        eachLog.showIcons = false;
      }
    });
    // country?: string;
    // method: string;
    // type:string;
    // sub_type?:string;
    // emission_source?:string;
    // categoryId: string;
    const reqObj: any = {
      category: emissionData[0].category,
      method: emissionData[0].method,
      type: emissionData[0].type,
    };

    if (emissionLog[index].country) reqObj.country = emissionLog[index].country;
    if (emissionData[0].sub_type) reqObj.sub_type = emissionData[0].sub_type;
    if (emissionLog[index].emission_source) {
      reqObj.emission_source = emissionLog[index].source_id;
    }

    let data;
    if (emissionData[0].category === 23) {
      data = await (await getEmissionCurrencyService()).data;
    } else {
      data = await (await getUOMService(reqObj)).data[0].uoms;
    }
    emissionLog[index].uoms = data;
    setEmissionLog([...emissionLog]);
  };

  const editAttachments = (data: any, type: any) => {
    let currEmissionAttachments = [];
    let currEmissionLogAttachments = [];
    if (type === "emission") {
      let currEmissionIndex: any = emissionData.findIndex(
        (eachLog: any) => eachLog.id === data.id
      );
      if (currEmissionIndex > -1) {
        const updatedEmission: any = emissionData;
        updatedEmission[currEmissionIndex].attachments = [...data.attachments];
        currEmissionAttachments =
          updatedEmission[currEmissionIndex].attachments;
        setEmissionData([...updatedEmission]);
      }
    } else {
      let currEmissionIndex: any = emissionLog.findIndex(
        (eachLog: any) => eachLog.id === data.id
      );
      if (currEmissionIndex > -1) {
        const updatedEmissionLog: any = emissionLog;
        updatedEmissionLog[currEmissionIndex].attachments = [
          ...data.attachments,
        ];
        currEmissionLogAttachments =
          updatedEmissionLog[currEmissionIndex].attachments;
        setEmissionLog([...updatedEmissionLog]);
      }
    }
    const requestData = {
      id: data.id,
      type: type,
      attachments: {
        files:
          type === "emission"
            ? currEmissionAttachments
            : currEmissionLogAttachments,
      },
    };
    updateEmissionAttachmentService(requestData)
      .then((res) => {
        toastMessage(successMessage().EMISSION_UPDATE_SUCCESS, "success");
        setToggleSave(!toggleSave);
      })
      .catch((e) => {
        console.error(e?.response?.data?.message);
        toastMessage(e?.response?.data?.message, "error");
      });
  };
  const handleSave = (index: number) => {
    emissionLog[index].isEditSelected = false;
    emissionLog[index].value = emissionLog[index].editedValue;
    emissionLog[index].showSave = false;
    setEmissionLog([...emissionLog]);

    let emissionReqData: any = {
      emissionLogId: emissionLog[index].id.toString(),
      emissionId: emissionData[0].id.toString(),
      uom: emissionLog[index].uom.toString(),
      Value: emissionLog[index].value.toString(),
      uomName: emissionLog[index].uomName
        ? emissionLog[index].uomName
        : emissionLog[index].uom_name.toString(),
    };
    if (emissionLog[index].fuel_id) {
      emissionReqData.fuel = emissionLog[index].fuel_id;
    }
    if (emissionData[0].type) {
      emissionReqData.type = emissionData[0].type;
    }
    if (emissionLog[index].emission_source_sub_type) {
      emissionReqData.emission_source_sub_type =
        emissionLog[index].emission_source_sub_type;
    }
    if (emissionLog[index].engine_id) {
      emissionReqData.engine_type = emissionLog[index].engine_id;
    }
    updateEmissionLogService(emissionReqData)
      .then((res) => {
        toastMessage(successMessage().EMISSION_UPDATE_SUCCESS, "success");
        setToggleSave(!toggleSave);
      })
      .catch((e) => {
        console.error(e.response.data.message);
        toastMessage(e.response.data.message, "error");
      });
  };
  const handleCloseEdit = (index: number) => {
    emissionLog[index].isEditSelected = false;
    emissionLog[index].showSave = false;
    setEmissionLog([...emissionLog]);
  };
  const handleShowIcons = (index: number, value: boolean) => {
    emissionLog[index].showIcons = value;
    setEmissionLog([...emissionLog]);
  };
  const handleHover = (index: number, value: boolean) => {
    emissionLog[index].isHover = value;
    setEmissionLog([...emissionLog]);
  };

  const editEmissionValue = (event: any, index: number) => {
    if (!isNaN(event.target.value)) {
      emissionLog[index].editedValue = event.target.value;
      setEmissionLog([...emissionLog]);
    }
  };
  const handleUOMChange = (event: any, sourceIndex: number) => {
    console.log(event);
    let uom: any = emissionLog[sourceIndex].uoms.find(
      (eachUom: any) => eachUom.id === event.target.value
    );
    let srcList = emissionLog;
    srcList[sourceIndex].uom = uom.id;
    srcList[sourceIndex].uomName = uom
      ? uom.symbol
      : srcList[sourceIndex].uom_name;
    setEmissionLog([...srcList]);
  };

  return (
    <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main pw-emission-width gap-3">
      <div className="pw-emission-card-header flex flex-row justify-between pb-5">
        {/* <div className="flex flex-col gap-1"> */}
        {/* <div className="pw-emission-transaction flex flex-row items-center gap-1">
            <p className="text-neutral-500 text-sm">{t("Transaction ID")} : </p>
            <p className="text-neutral-900 text-sm font-bold"> 2334545J</p>
          </div> */}
        <div className="pw-emission-transaction flex flex-row items-center gap-1">
          <p className="text-neutral-500 text-sm">{t("Emission ID")} : </p>
          <p className="text-neutral-900 text-sm font-bold">
            {" "}
            {emissionData[0]?.code}
          </p>
        </div>
        {/* </div> */}
        <div className="flex gap-3 pr-2">
          {/* <Button onClick={openEdit} className="pw-editbox-emission">
            <CreateIcon className="pw-emission-edit-icon text-neutral-600" />
            <div className="pw-edit">Edit</div>
          </Button> */}
          {index > 0 && (
            <div onClick={() => onNavigateNext(-1)} className="pw-navigate">
              <img
                src="assets/icons/prev.svg"
                alt=" "
                className="pw-emission-image"
              />
            </div>
          )}
          {index < total_count - 1 && (
            <div
              onClick={() => onNavigateNext(1)}
              className="pw-navigate pw-next"
            >
              <img
                src="assets/icons/next.svg"
                alt=" "
                className="pw-emission-image"
              />
            </div>
          )}

          <div onClick={() => onClose()} className="pw-navigate">
            <CloseIcon className="text-neutral-600" />
          </div>
        </div>
      </div>
      <div className="pw-category-card flex flex-col">
        <div className="pw-cat-card-top flex flex-row pb-4 w-full pw-border-bottom justify-between">
          <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-1">
              <p className="text-neutral-700 text-sm">
                {emissionData[0]?.category_code}
              </p>
              <p className="text-neutral-900 text-base">
                {emissionData[0]?.category_name}
              </p>
            </div>
            <div className="flex flex-row items-center gap-1">
              <p className="text-neutral-700 text-sm">{t("Duration")} :</p>
              <p className="text-neutral-900 text-sm">
                {parseDateMonth(emissionData[0]?.from_date)}
              </p>
            </div>
            <div className="flex flex-row items-center gap-1">
              <>
                <p className="text-neutral-700 text-sm">{t("Status")} :</p>
                <p
                  className={`text-success text-sm pw-status-dropdown-${statusData?.status} font-bold`}
                >
                  {statusData?.status === EMISSION_DATA_STATUS_TYPE.REJECTED ||
                  !(statusData?.status === EMISSION_DATA_STATUS_TYPE.APPROVED
                    ? checkPermissions(
                        ["UPDATE_APPROVED_EMISSIONS"],
                        permissions
                      )
                    : checkPermissions(
                        ["UPDATE_EMISSION_STATUS"],
                        permissions
                      )) ? (
                    <div
                      className={`pw-${statusData?.status?.toLowerCase()}-option pw-status-option-btn font-bold pw-bg-primary-200`}
                    >
                      {statusData?.status}
                    </div>
                  ) : (
                    <Box>
                      <FormControl
                        fullWidth
                        size="small"
                        className="pw-form-select"
                      >
                        <AntSelect
                          dropdownStyle={{
                            minWidth: "8rem",
                            paddingRight: "12px",
                          }}
                          suffixIcon={
                            <CaretDownOutlined className="!pointer-events-none" />
                          }
                          value={statusData?.status}
                          className="pw-status-selection"
                          onChange={(event: any) => {
                            handleStatusChange(
                              event,
                              currentIndex,
                              statusData,
                              "detailView"
                            );
                          }}
                        >
                          {statusOptions[statusData?.status]?.map(
                            (name: any, index: number) => {
                              return (
                                <Option
                                  value={name}
                                  // className={`pw-${name?.toLowerCase()}-option  pw-margin-10 pw-status-option-btn font-bold pw-bg-primary-200`}
                                  className={` pw-margin-10 font-bold pw-${name.toLowerCase()}-option`}
                                >
                                  {name}
                                </Option>
                              );
                            }
                          )}
                        </AntSelect>
                      </FormControl>
                    </Box>
                  )}
                </p>
              </>
            </div>
            {cellColumnsForVerifer === true && (
              <div className="flex flex-row">
                <div>Verifier action:</div>
                <Checkbox
                  icon={<CircleOutlinedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                  onChange={(event: any) =>
                    handleExternalVerifierStatus(
                      event,
                      currentIndex,
                      emissionData[0],
                      true
                    )
                  }
                  checked={
                    emissionData[0].verify_status === "Verified" ? true : false
                  }
                />
              </div>
            )}
          </div>
          <div className="flex flex-col items-end gap-2">
            <div className="flex flex-row gap-2 items-center">
              {/* <div className="pw-category-name-background gap-1">
                <p className="text-neutral-800 text-xs">Cat 1.3</p>
                <p className="text-neutral-900 text-xs">Category Name</p>
              </div> */}
              <div className="text-neutral-900 text-sm font-bold">
                {parseFloat(emissionData[0]?.total_value).toFixed(2)}
                &nbsp;{t("kg CO2e")}
              </div>
            </div>
            <div className="flex flex-row gap-2 items-center">
              {/* <div className="pw-category-name-background gap-1">
                <p className="text-neutral-800 text-xs">Cat 2</p>
                <p className="text-neutral-900 text-xs">Category Name</p>
              </div> */}
              {/* <div className="text-neutral-900 text-sm font-bold">
                {emissionData.totalValue}&nbsp;KgCO2e
              </div> */}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between pt-5">
          <div className="flex flex-row gap-1 items-center">
            <p className="text-neutral-600 text-sm">{t("Modified on")} : </p>
            <p className="text-sm text-neutral-900">
              {dateParser(emissionData[0]?.last_updated)}
            </p>
          </div>
          <div className="flex flex-row gap-1 items-center">
            <p className="text-neutral-600 text-sm">{t("Modified by")} : </p>
            <p className="text-neutral-900 text-sm">
              {emissionData[0]?.last_updated_by_name || "-"}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col pw-detail-main-content gap-5">
        <div className="flex flex-row gap-1 items-center">
          <p className="text-neutral-600 text-sm">
            {t("Log Emission against")} :{" "}
          </p>
          <p className="text-neutral-900 text-sm">
            {emissionData[0]?.method_name || "-"}
          </p>
        </div>
        <div className="flex flex-row gap-1 items-center">
          <p className="text-neutral-600 text-sm">
            {t("Emission factor source")} :{" "}
          </p>
          <p className="text-neutral-900 text-sm">
            {emissionData[0]?.type_name + " " + emissionData[0]?.sub_type_name}
          </p>
        </div>
        <div className="mb-3">
          <TableContainer className="mb-1 pw-emission-table-container">
            <Table aria-label="simple table" className="pw-emission-head">
              <TableHead>
                <TableRow className="bg-neutral-50">
                  <TableCell className=" !text-neutral-600">
                    {tab === STEPS.ASSETS
                      ? "Asset ID"
                      : getSourceNameByCategory(emissionData[0])}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ minWidth: "5rem" }}
                    className=" !text-neutral-600"
                  >
                    {/* {emissionData[0]?.method_name === "Cradle to Production" ||
                    emissionData[0]?.method_name === "Cradle to Point of Sale"
                      ? emissionData[0]?.method_name
                      : emissionData[0]?.method_name?.split(" ")[0] || "-"} */}
                    {t("Activity Data")}
                  </TableCell>
                  <TableCell
                    align="left"
                    className=" !text-neutral-600"
                  ></TableCell>
                  <TableCell align="right" className=" !text-neutral-600">
                    {t("Emissions (kg CO2e)")}
                  </TableCell>
                  <TableCell align="right" className=" !text-neutral-600">
                    {t("Emission ID")}
                  </TableCell>
                  <TableCell align="left" style={{ width: "5rem" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {emissionLog.map((row: any, index: number) => {
                  return (
                    <>
                      <TableRow
                        className="pw-emission-row"
                        onMouseEnter={() => {
                          handleShowIcons(index, true);
                          // let tempList = emissionLog;
                          // tempList[index].showIcons = true
                          // setEmissionLog(tempList);
                        }}
                        onMouseLeave={() => {
                          !emissionLog[index].showSave &&
                            handleShowIcons(index, false);
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          align="left"
                          style={{
                            borderBottom:
                              index === emissionLog.length - 1 ? "none" : "",
                            paddingLeft: "1rem !important",
                          }}
                        >
                          <div>
                            {tab === STEPS.ASSETS && (
                              <div
                                style={{ fontSize: "14px" }}
                                className="pw-text-neutral-900"
                              >
                                {emissionLog[0].local_code}
                              </div>
                            )}
                            <span className="text-neutral-600 text-xs">
                              {getSourceValue(
                                emissionData[0],
                                emissionLog[index]
                              )}
                            </span>
                          </div>
                          {emissionLog[index]?.engine_name && (
                            <div className="text-neutral-600 text-xs">
                              {emissionLog[index]?.engine_name}
                            </div>
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            borderBottom:
                              index === emissionLog.length - 1 ? "none" : "",
                          }}
                        >
                          {!emissionLog[index]["isEditSelected"] ? (
                            parseFloat(emissionLog[index]?.value).toFixed(2)
                          ) : (
                            <TextField
                              sx={{
                                input: {
                                  textAlign: "right",
                                  fontSize: "0.875rem",
                                },
                              }}
                              variant="standard"
                              className="pw-input-text"
                              style={{
                                width: "3.4rem",
                                height: "0.5rem",
                                marginBottom: "1rem",
                                textAlign: "right",
                              }}
                              defaultValue={parseFloat(
                                emissionLog[index]?.value
                              ).toFixed(2)}
                              onChange={(event) => {
                                editEmissionValue(event, index);
                              }}
                              type="text"
                            ></TextField>
                          )}
                        </TableCell>

                        <TableCell
                          align="left"
                          className="pw-small-row !text-neutral-600 !text-xs"
                          style={{
                            borderBottom:
                              index === emissionLog.length - 1 ? "none" : "",
                          }}
                        >
                          {emissionLog[index].uom &&
                          emissionLog[index].uoms?.length > 1 &&
                          emissionLog[index]["isEditSelected"] ? (
                            <Select
                              className="pw-emission-select w-50vh pb-3 gap-5"
                              size="small"
                              value={emissionLog[index].uom}
                              onChange={(event: any) => {
                                handleUOMChange(event, index);
                              }}
                            >
                              {emissionLog[index].uoms.map((eachUOM: any) => (
                                <MenuItem value={eachUOM.id}>
                                  {emissionData[0].category === 23
                                    ? eachUOM.symbol
                                    : eachUOM.symbol.split("/")[1]}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : (
                            <p>
                              {emissionData[0].category === 23
                                ? emissionLog[index]?.uom_name
                                : emissionLog[index]?.uom_name?.split("/")[1]}
                            </p>
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          className="!pr-2"
                          style={{
                            borderBottom:
                              index === emissionLog.length - 1 ? "none" : "",
                          }}
                        >
                          {parseFloat(emissionLog[index]?.total_value).toFixed(
                            2
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            borderBottom:
                              index === emissionLog.length - 1 ? "none" : "",
                          }}
                        >
                          {emissionLog[index].log_code}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            borderBottom:
                              index === emissionLog.length - 1 ? "none" : "",
                          }}
                        >
                          {emissionLog[index].showIcons && (
                            <Fragment>
                              <div className="flex flex-row gap-1">
                                {emissionLog[index].showSave ? (
                                  <div>
                                    <CheckIcon
                                      className="!bg-primary-500 mr-2 text-sm !rounded p-1"
                                      sx={{
                                        backgroundColor: `${
                                          Number(emissionLog[index].value)
                                            ? primaryColor
                                            : neutral[300]
                                        }`,
                                        color: "white",
                                        borderRadius: "5%",
                                      }}
                                      onClick={() => {
                                        if (Number(emissionLog[index].value)) {
                                          handleSave(index);
                                        }
                                      }}
                                    />
                                    <CloseIcon
                                      onClick={() => {
                                        handleCloseEdit(index);
                                      }}
                                      className="text-neutral-600 border-solid border-2 rounded p-0.5"
                                    />
                                  </div>
                                ) : (
                                  <Fragment>
                                    <div
                                      className="pw-attachment-icon cursor-pointer"
                                      onClick={() =>
                                        handleOpenAttachments(index)
                                      }
                                    >
                                      <AttachmentIcon className="pw-rotate-50 pw-color-neutral-200" />
                                      <div className="pw-attachment-count">
                                        {
                                          emissionLog[index]?.attachments
                                            ?.length
                                        }
                                      </div>
                                    </div>
                                    <InfoIcon
                                      className="text-neutral-600 text-xs "
                                      onMouseEnter={() => {
                                        handleHover(index, true);
                                      }}
                                      onMouseLeave={() => {
                                        handleHover(index, false);
                                      }}
                                    />
                                    {(statusData?.status ===
                                    EMISSION_DATA_STATUS_TYPE.APPROVED
                                      ? checkPermissions(
                                          ["UPDATE_APPROVED_EMISSIONS"],
                                          permissions
                                        )
                                      : checkPermissions(
                                          ["UPDATE_EMISSIONS"],
                                          permissions
                                        )) &&
                                    statusData?.status !==
                                      EMISSION_DATA_STATUS_TYPE.REJECTED ? (
                                      <CreateIcon
                                        onClick={() => {
                                          handleEdit(index);
                                        }}
                                        className="text-neutral-600 text-xs p-0.5 cursor-pointer"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </Fragment>
                                )}
                              </div>
                            </Fragment>
                          )}
                        </TableCell>
                      </TableRow>
                      <div className="flex flex-row gap-1 justify-end items-center">
                        {/* <p className="text-neutral-600 text-xs">Emission factor :</p>
                         <p className="text-neutral-600 text-xs">0.143</p> */}

                        {emissionLog[index].isHover && (
                          // <Dialog  open={true} className="flex flex-col pw-dialogbox">
                          <div
                            className="flex flex-col gap-5 pw-dialogbox"
                            onMouseEnter={() => {
                              handleHover(index, true);
                            }}
                            onMouseLeave={() => {
                              handleHover(index, false);
                            }}
                          >
                            <div className="flex flex-row gap-2">
                              <p className="text-neutral-600">
                                {" "}
                                {t("Source")}:
                              </p>
                              <p className="font-bold">
                                {emissionLog[index].factor_source_name}
                              </p>
                            </div>
                            <div className="flex flex-row justify-between ">
                              <div className="flex flex-row">
                                <p className="text-neutral-600">
                                  {t("Data ID")}:
                                </p>
                                &nbsp;
                                <p className="">
                                  {emissionLog[index]?.emission_factor_code}
                                </p>
                              </div>
                            </div>
                            <hr />
                            {emissionLog[index]?.original_description ? (
                              <div className="flex flex-row">
                                <p className="text-neutral-600">
                                  {t("Original Description")}:&nbsp;{" "}
                                </p>
                                <p>
                                  {" "}
                                  {emissionLog[index]?.original_description}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="flex flex-row">
                              <p className="text-neutral-600">
                                {t("Method Name")}:&nbsp;{" "}
                              </p>
                              <p> {emissionData[0]?.method_name}</p>
                            </div>
                            <div className="flex flex-row">
                              <p className="text-neutral-600">
                                {getSourceNameByCategory(emissionData[0])}
                                :&nbsp;
                              </p>
                              <p>
                                {getSourceValue(
                                  emissionData[0],
                                  emissionLog[index]
                                )}
                              </p>
                            </div>

                            <hr />
                            {!emissionLog[index].is_default && (
                              <div className="flex flex-row">
                                <p className="text-neutral-600">Year:&nbsp; </p>
                                <p>
                                  {" "}
                                  {parseDateMonth(
                                    emissionLog[index]?.emissionfactor_from_date
                                  )}{" "}
                                  -{" "}
                                  {parseDateMonth(
                                    emissionLog[index]?.emissionfactor_to_date
                                  )}{" "}
                                </p>
                              </div>
                            )}
                            <div className="flex flex-row justify-between">
                              <div className="flex flex-row flex-wrap">
                                <p className="flex flex-row text-neutral-600 gap-1">
                                  {t("Emission factor")}
                                  <p> ({emissionLog[index].uom_name}) </p>
                                  :&nbsp;
                                </p>
                                {emissionLog[index]?.values &&
                                  Object.entries(
                                    emissionLog[index]?.values
                                  ).map(([key, value], id: any) => (
                                    <p
                                      className={`${
                                        Object.keys(emissionLog[index].values)
                                          .length > 1
                                          ? "flex flex-row pw-emission-factor mr-1 ml-1 mb-2 p-1"
                                          : ""
                                      }`}
                                    >
                                      {key + " : " + value + " "}{" "}
                                    </p>
                                  ))}
                              </div>
                            </div>
                            {emissionLog[index]?.gwp_values &&
                            Object.keys(emissionLog[index].gwp_values)
                              .length ? (
                              <div className="flex flex-row justify-between">
                                <div className="flex flex-row flex-wrap">
                                  <p className="flex flex-row text-neutral-600 gap-1">
                                    {t("GWP Values")} :&nbsp;
                                  </p>
                                  {emissionLog[index]?.gwp_values &&
                                    Object.entries(
                                      emissionLog[index]?.gwp_values
                                    ).map(([key, value], id: any) => (
                                      <p
                                        className={`${
                                          Object.keys(
                                            emissionLog[index].gwp_values
                                          ).length > 1
                                            ? "flex flex-row pw-emission-factor mr-1 ml-1 mb-2 p-1"
                                            : ""
                                        }`}
                                      >
                                        {key + " : " + value + " "}{" "}
                                      </p>
                                    ))}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  );
                })}
              </TableBody>
            </Table>
            {/* <ShowDialog
              index={index}
              isHover={isHover}
              emissionLog={emissionLog}
              setEmissionLog={setEmissionLog}
               emissionData={emissionData}
              setIsHover={setIsHover}
            /> */}
          </TableContainer>

          <div className="relative">
            {(statusData?.status === EMISSION_DATA_STATUS_TYPE.APPROVED
              ? checkPermissions(["UPDATE_APPROVED_EMISSIONS"], permissions)
              : checkPermissions(["UPDATE_EMISSIONS"], permissions)) &&
            statusData?.status !== EMISSION_DATA_STATUS_TYPE.REJECTED ? (
              <div
                onClick={() => setEditAttachmentsData(true)}
                className="absolute underline pw-edit-button"
              >
                Edit
              </div>
            ) : (
              ""
            )}
            <FileAttachmentsDetails
              emissionAttachmentData={emissionAttachmentData}
              setEmissionAttachmentData={setEmissionAttachmentData}
              fromEmissionDetail={true}
              emissionStatus={statusData?.status}
            />
          </div>

          {editAttachmentsData && (
            <FileAttachments
              emissionAttachmentData={emissionAttachmentData}
              setEmissionAttachmentData={setEmissionAttachmentData}
              fromEmissionDetailParent={true}
              setEditAttachmentsData={setEditAttachmentsData}
              editAttachments={editAttachments}
              emissionStatus={statusData?.status}
            />
          )}
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-sm text-neutral-600">{t("Notes")} : </p>
          <p className="text-sm text-neutral-900">
            {emissionData[0]?.comments ? emissionData[0]?.comments : "-"}
          </p>
        </div>
      </div>
      {versionHistoryData.length > 0 && (
        <EmissionVersionHistory versionHistoryData={versionHistoryData} />
      )}

      {showAttachment && (
        <FileAttachments
          emissionLogAttachmentData={emissionLogAttachmentData}
          setEmissionLogAttachmentData={setEmissionLogAttachmentData}
          showAttachment={showAttachment}
          setShowAttachment={setShowAttachment}
          editAttachments={editAttachments}
          cellColumns={cellColumns}
          emissionStatus={statusData?.status}
        />
      )}
    </div>
  );
}

export default EmissionDetailedView;
